import {
  hideDialog,
  refresher,
  showDialog,
} from "../../../redux/guest-slices/other.slice";
import { handleUserLoginReq } from "../../../redux/user-slices/auth.slice";
import { GUEST_SIGNUP } from "../../../utils/keywords";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../../../hooks/useToast";
import FacebookLogin from "../../ui/FacebookLogin";
import { Link as NavLink } from "react-router-dom";
import GoogleLogin from "../../ui/GoogleLogin";
import Icons from "../../../assets/js/Icons";
import { useState } from "react";

import {
  Box,
  Button,
  CircularProgress,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2 as Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

function Login() {
  const toast = useToast();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const { other } = useSelector((state) => state.memberSlice);

  // Handle user signup
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    if (
      Object.keys(formData)?.some((field) => {
        const value = formData[field];
        return value?.trim() === "" || !value;
      })
    ) {
      return toast.error("Please fill all required field!");
    }
    formData.stay = true;
    await dispatch(handleUserLoginReq(formData));
    setTimeout(() => {
      handleClose();
      dispatch(refresher());
    }, 500);
  };

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog());
  };

  // Handle signup
  const handleSignup = () => {
    dispatch(showDialog(GUEST_SIGNUP));
  };

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          Login To Post
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "black",
            position: "absolute",
            bgcolor: "#0000001f !important",
          }}
          size="small"
          onClick={handleClose}
        >
          <Icons.Cross />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
          textarea: { resize: "none" },
        }}
      >
        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              size="small"
              name="email"
              label="Email"
              variant="filled"
              varianttype="login"
            />
            <TextField
              size="small"
              name="password"
              label="Password"
              variant="filled"
              varianttype="login"
              type={show ? "text" : "password"}
              slotProps={{
                input: {
                  endAdornment: (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setShow(!show);
                      }}
                    >
                      {!show ? <Icons.ViewSolid /> : <Icons.ViewOffSolid />}
                    </IconButton>
                  ),
                },
              }}
            />
            <Typography fontSize={14} color="other.color1" textAlign="end">
              <Link
                underline="hover"
                component={NavLink}
                to="/forgot-password"
                onClick={handleClose}
              >
                Forgot password?
              </Link>
            </Typography>
            <Button
              sx={{
                p: "9px 17px",
                lineHeight: "1.5",
                fontSize: "18px",
                justifyContent: "center",
              }}
              type="submit"
              color="secondary"
              variant="contained"
              endIcon={
                other?.loadingLogin && (
                  <CircularProgress size={22} color="text" thickness={6} />
                )
              }
            >
              Login
            </Button>
            <Divider>
              <Typography component="span" sx={{ color: "#d4d4d4" }}>
                Or
              </Typography>
            </Divider>
            <Grid container spacing={1}>
              <Grid size={{ xs: 12, md: 6 }}>
                <FacebookLogin handleClose={handleClose} stay={true} />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <GoogleLogin handleClose={handleClose} stay={true} />
              </Grid>
            </Grid>
            <Typography mb={3} color="other.color1" textAlign="center">
              By continuing you indicate that you agree to Quora's to InnerPals{" "}
              <Link
                underline="hover"
                sx={{ mb: "20px" }}
                component={NavLink}
                onClick={handleClose}
                to="/terms-and-conditions"
              >
                {" "}
                Terms of Service
              </Link>{" "}
              and{" "}
              <Link
                underline="hover"
                to="/privacy-policy"
                sx={{ mb: "20px" }}
                component={NavLink}
                onClick={handleClose}
              >
                {" "}
                Privacy Policy
              </Link>
              .
            </Typography>
            <Typography
              mb={3}
              fontSize={14}
              color="other.color1"
              textAlign="center"
            >
              Don't have an account?{" "}
              <Link
                type="button"
                underline="hover"
                component="button"
                onClick={handleSignup}
              >
                Register
              </Link>
            </Typography>
          </Stack>
        </Box>
      </DialogContent>
    </Paper>
  );
}

export default Login;
